
import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { GetLeavsAllemployesss } from '../../services/dataService';
import toast from 'react-hot-toast';
import { getSecureItem } from '../../services/SecureStorage';

function TodayLeave() {
    const UID = getSecureItem("userId");
    const location = useLocation();
    const isAdmin = getSecureItem("IsAdmin");

    const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
    const Dep = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
    const [loading, setLoading] = useState(false);
    const [allEmpLeaveReq, setAllEmpLeaveReq] = useState([]);
    const [ApprovedLeaveToday, setApprovedLeaveToday] = useState([]);
    const [filteredLeaves, setFilteredLeaves] = useState([]);
    const [ApprovedLeaves, setApprovedLeaves] = useState(() => location.state?.ApprovedLeaves || []);

    // Filter states
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedProfitCenterName, setselectedProfitCenterName] = useState('');
    const [departments, setDepartments] = useState([]);
    const [profitCenters, setProfitCenters] = useState([]);




    const { selectedProfitCenter } = location.state || {};


    useEffect(() => {
        setselectedProfitCenterName(selectedProfitCenter)
    }, [selectedProfitCenter])

    const fetchAllEmpLeaveReq = async () => {
        try {
            setLoading(true);
            const data = {
                Date: new Date().toISOString().split("T")[0],
                UserId: UID,
            };

            const response = await GetLeavsAllemployesss(data);

            if (response?.data?.data) {
                setAllEmpLeaveReq(response.data.data);
            } else {
                console.error("Invalid response structure:", response);
                toast.error("Failed to load leave requests - invalid data format");
            }
        } catch (error) {
            console.error("API Error:", error);
            toast.error(error.response?.data?.message || "Failed to fetch leave requests");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllEmpLeaveReq();
    }, []);

    useEffect(() => {
        if (ApprovedLeaves && Array.isArray(ApprovedLeaves)) {
            const LeaveFromDashBoard = allEmpLeaveReq.filter((el) =>
                ApprovedLeaves.some((p) => p.Id === el.Id)
            );
            setApprovedLeaveToday(LeaveFromDashBoard);
        }
    }, [ApprovedLeaves, allEmpLeaveReq]);

    // Extract unique departments and profit centers
    useEffect(() => {
        const uniqueDepartments = [...new Set(ApprovedLeaveToday.map(leave => leave.DepartmentName).filter(Boolean))];
        setDepartments(uniqueDepartments);

        const uniqueProfitCenters = [...new Set(ApprovedLeaveToday.map(leave => leave.ProfitcenterName).filter(Boolean))];
        setProfitCenters(uniqueProfitCenters);
    }, [ApprovedLeaveToday]);

    // Filter leaves based on search, department, and profit center
    useEffect(() => {
        let filtered = ApprovedLeaveToday;

        // Filter by search term (name, code, or department)
        if (searchTerm) {
            filtered = filtered.filter(leave =>
                leave.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                leave.NameWithCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                leave.DepartmentName?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by department
        if (selectedDepartment) {
            filtered = filtered.filter(leave => leave.DepartmentName === selectedDepartment);
        }

        // Filter by profit center
        if (selectedProfitCenterName) {
            filtered = filtered.filter(leave => leave.ProfitcenterName === selectedProfitCenterName);
        }

        setFilteredLeaves(filtered);
    }, [ApprovedLeaveToday, searchTerm, selectedDepartment, selectedProfitCenterName]);

    // Extract employee code from NameWithCode
    const getEmployeeCode = (nameWithCode) => {
        if (!nameWithCode) return 'N/A';
        const parts = nameWithCode.split(' - ');
        return parts.length > 1 ? parts[1] : 'N/A';
    };

    // Extract employee name from NameWithCode
    const getEmployeeName = (nameWithCode, name) => {
        if (nameWithCode) {
            const parts = nameWithCode.split(' - ');
            return parts[0] || name || 'N/A';
        }
        return name || 'N/A';
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <div className="container mx-auto p-6 bg-white min-h-screen">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">Employees On Leave Today  {selectedProfitCenter ? `on ${selectedProfitCenter}` : ''}</h1>
                        {isAdmin == 0 && filteredLeaves?.length > 0 && (
                            <>
                                <p className="text-2xl text-gray-800">
                                    Department: {[...new Set(filteredLeaves.map((el) => el.DepartmentName))].join(", ")}
                                </p>
                            </>
                        )}


                        <p className="text-gray-600 mt-1">
                            {new Date().toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                            Total Leave Requests: {filteredLeaves.length}
                        </p>
                    </div>
                    <Link
                        to="/"
                        className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center"
                    >
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Back to Dashboard
                    </Link>
                </div>

                {/* Filter Section */}
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <div className="flex flex-col md:flex-row gap-4">
                        {/* Search Input */}
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Search by Name, Code, or Department
                            </label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Enter employee name, code, or department..."
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        {/* Department Filter */}
                        {isAdmin == 1 &&
                            <div className="md:w-64">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Filter by Department
                                </label>
                                <select
                                    value={selectedDepartment}
                                    onChange={(e) => setSelectedDepartment(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">All Departments</option>
                                    {departments.map((dept, index) => (
                                        <option key={index} value={dept}>
                                            {dept}
                                        </option>
                                    ))}
                                </select>
                            </div>}

                        {/* Profit Center Filter */}
                        {!selectedProfitCenter &&
                            <div className="md:w-64">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Filter by Profit Center
                                </label>
                                <select
                                    value={selectedProfitCenterName}
                                    onChange={(e) => setselectedProfitCenterName(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">All Profit Centers</option>
                                    {profitCenters.map((center, index) => (
                                        <option key={index} value={center}>
                                            {center}
                                        </option>
                                    ))}
                                </select>
                            </div>}
                    </div>
                </div>
            </div>

            {/* Loading State */}
            {loading && (
                <div className="flex justify-center items-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <span className="ml-2 text-gray-600">Loading...</span>
                </div>
            )}

            {/* Table */}
            {!loading && (
                <div className="overflow-x-auto shadow-lg rounded-lg">
                    <table className="min-w-full bg-white border border-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Sl No
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Employee Code
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Employee Name
                                </th>{isAdmin == 1 &&
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                        Department
                                    </th>}
                                {!selectedProfitCenter &&
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                        Profitcenter
                                    </th>}
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Leave Type
                                </th>
                                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    No of Days
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    From
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    To
                                </th> */}

                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {filteredLeaves.length > 0 ? (
                                filteredLeaves.map((leave, index) => (
                                    <tr key={leave.Id} className="hover:bg-gray-50 transition-colors duration-200">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {getEmployeeCode(leave.NameWithCode)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {getEmployeeName(leave.NameWithCode, leave.Name)}
                                        </td>
                                        {isAdmin == 1 &&
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                                {leave.DepartmentName || 'N/A'}
                                            </td>}
                                        {!selectedProfitCenter &&
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                                {leave.ProfitcenterName || 'N/A'}
                                            </td>}
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {leave.LeaveTypeName || 'N/A'}
                                        </td>
                                        {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {leave.NoOfDays || 0}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {formatDate(leave.FromDate)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {formatDate(leave.ToDate)}
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                                        {searchTerm || selectedDepartment || selectedProfitCenterName ?
                                            'No employees found matching your search criteria.' :
                                            'No employees on leave today.'
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Results Count */}
            {!loading && filteredLeaves.length > 0 && (
                <div className="mt-4 text-sm text-gray-600">
                    Showing {filteredLeaves.length} of {ApprovedLeaveToday.length} employees
                    {(searchTerm || selectedDepartment || selectedProfitCenterName) && ' (filtered)'}
                </div>
            )}
        </div>
    );
}

export default TodayLeave;
